import { createLucideIcon } from "lucide-react";

export const Menu3 = createLucideIcon(
    "Menu3",
    [
        [
            "path",
            {
                d: "M11.9998 5H12.0088",
                key: "1ldile",
            },
        ],
        [
            "path",
            {
                d: "M5 14L19 14",
                key: "1y86qt",
            },
        ],
        [
            "path",
            {
                d: "M5 19L19 19",
                key: "qy0ruu",
            },
        ],
        [
            "path",
            {
                d: "M5 9L19 9",
                key: "17bwjd",
            },
        ],
    ],
);
